"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  rpc: {},
  types: {
    ChainId: {
      _enum: {
        RelayChain: 'Null',
        ParaChain: 'ParaId'
      }
    },
    XCurrencyId: {
      chainId: 'ChainId',
      currencyId: 'Vec<u8>'
    }
  }
};
exports.default = _default;